import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './add-device-modal';

class BinDeleteButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-icon {
        margin-right: .25em;
      }
    `];
  }

  render() {
    return html`
      <button class="button button--contained" @click="${this._onClick}">
        <bn-icon name="fal fa-plus"></bn-icon> Add Device
      </button>

      <add-device-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></add-device-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('add-device-button', BinDeleteButton);
